<template>
  <div class="red-packet2-dialog">
    <div class="red-packet2-content" slot="custom">
      <div v-if="data.couponDetailType === 'A'" class="red-packet2-title">
        <img src="../../images/hongbao_2_20.png" />
      </div>
      <div v-if="data.couponDetailType === 'B'" class="red-packet2-title">
        <img src="../../images/hongbao_2_100.png" />
      </div>
      <div class="red-packet2-desc">
        提取你的现金红包
      </div>
      <div class="red-packet2-item" @click="openRedPacket">
        <img class="middle" src="../../images/hongbao.png" />
        <img
          class="finger"
          src="../../images/finger.png"
        />
      </div>
      <div class="ignore" @click="handleTextButtonClick">
        给钱也不要
      </div>
      <div class="expire-time">
        请及时领取现金红包
      </div>
    </div>
  </div>
</template>
<script>
import { setKey } from '@/assets/utils'

export default {
  data () {
    return {
      visible: true
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    show () {
      setKey('RED_PACKET_2_SHOW_TIME', Date.now())
      this.$report({
        id: 10125,
        args: {
          visible: 1,
          status: this.data.couponDetailType
        }
      })
    },
    open () {
      this.visible = true
      setKey('RED_PACKET_2_SHOW_TIME', Date.now())
    },
    close (target) {
      this.$report({
        id: 10126,
        args: {
          target: target,
          status: this.data.couponDetailType
        }
      })
      this.visible = false
      this.$emit('close')
    },
    handleTextButtonClick () {
      this.close(2)
      setKey('RED_PACKE_SHOULD_SHOW', 'F')
    }, 
    openRedPacket () {
      this.$report({
        id: 10126,
        args: {
          target: 1,
          status: this.data.couponDetailType
        }
      })
      this.goActivityDetail()
    },

    goActivityDetail () {
      this.$router.push({
        path: '/activities/compensation',
        query: {
          loanPlatform: 'TMD',
          activeType: this.data.activeType,
          open: 1
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";


.red-packet2-dialog {
    .red-packet2-content {
        width: 620px;
        height: 750px;
        border-radius: 30px;
        background-color: #5267c7;
        padding-top: 46px;
        text-align: center;
        .red-packet2-title {
            img {
                display: inline-block;
                width: 490px;
                height: 58px;
            }
        }
        .red-packet2-desc {
            margin-top: 21px;
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 221, 105, 1);
            line-height: 45px;
        }
        .red-packet2-item {
            margin: 40px 0px;
            position: relative;
            img.middle {
                display: inline-block;
                width: 253px;
                height: 310px;
            }
            img.finger {
                position: absolute;
                display: inline-block;
                width: 134px;
                height: 147px;
                bottom: 0px;
                right: 154px;
                animation: shakeY 3s linear infinite;
            }
        }
        .ignore {
            text-decoration: underline;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 40px;
        }
        .expire-time {
            margin: 40px 0px;
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(221, 221, 221, 1);
            line-height: 30px;
        }
    }
}
</style>
